import {
	Button,
} from "@mui/material";
import React from "react";
import { theme } from "../../styles/themeProvider";

export const CancelButton = ({
	handleCancel,
	children,
}: {
	handleCancel: () => void;
	children: React.ReactNode;
}) => {
	return (
		<Button
			variant="outlined"
			sx={{
				width: "100px",
				fontWeight: 500,
				color: theme.palette.error.light,
				border: `2px solid ${theme.palette.error.light}`,
				borderColor: theme.palette.error.light,
				"&:hover": {
					backgroundColor: theme.palette.error.light,
					color: "#ffffff",
					borderColor: theme.palette.error.light,
				},
			}}
			onClick={handleCancel}
		>
			{children}
		</Button>
	);
};
